export default __webpack_public_path__ + "static/media/black_new.3f799b44.svg";